/**
 * Initialize MSAL instance with account storage events and set
 * active account if not set.
 */
export const initializeAuth = (instance) => {
    instance.enableAccountStorageEvents();
    if (!instance.getActiveAccount()) {
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }
    }
};
